<template>
  <JyPagebody :activatedLoad="initData">
    <el-form class="flex-grow-1 overflow-y-auto pb-3">
      <el-row type="flex" class="flex-wrap">
        <form-item label-width="0" class="mb-3 p0 border-none home-first" style="flex:0 0 60%; width:60%;" no-hover align-v="flow-start">
          <div class="mr-3 bg-white border rounded">
            <div class="d-flex p-3 justify-content-between flex-wrap">
              <jy-progress v-if="issys" type="circle" :percentage="100" :width="80" :stroke-width="3" :show-percentage="false" color="#f44336">
                <router-link class="d-block font1 line-h15 under-none" to="/news-list" style="color:#f44336"><strong class="font11">{{ counts.countnews }}</strong><br>内容</router-link>
              </jy-progress>
              <jy-progress type="circle" :percentage="100" :width="80" :stroke-width="3" :show-percentage="false">
                <router-link class="d-block font1 line-h15 under-none" to="/news-cate"><strong class="font11">{{ counts.countnewscate }}</strong><br>内容类别</router-link>
              </jy-progress>
              <!-- <jy-progress type="circle" :percentage="100" :width="80" :stroke-width="3" :show-percentage="false" color="#ff6600">
                <router-link class="d-block font1 line-h15 under-none" :to="{name:'base-topic'}" style="color:#ff6600"><strong class="font11">{{ counts.counttopic }}</strong><br>主题</router-link>
              </jy-progress> -->
              <jy-progress type="circle" :percentage="100" :width="80" :stroke-width="3" :show-percentage="false" color="#007bff">
                <router-link class="d-block font1 line-h15 under-none" to="/news-single" style="color:#007bff"><strong class="font11">{{ counts.countsingle }}</strong><br>单项内容</router-link>
              </jy-progress>
              <jy-progress type="circle" :percentage="100" :width="80" :stroke-width="3" :show-percentage="false" color="#4caf50">
                <router-link class="d-block font1 line-h15 under-none" to="/web-links" style="color:#4caf50"><strong class="font11">{{ counts.countlinks }}</strong><br>链接</router-link>
              </jy-progress>
              <jy-progress type="circle" :percentage="100" :width="80" :stroke-width="3" :show-percentage="false" color="#225d97">
                <router-link class="d-block font1 line-h15 under-none" to="/sys-employee" style="color:#225d97"><strong class="font11">{{ counts.countuser }}</strong><br>管理员</router-link>
              </jy-progress>
            </div>
            <div class="p-3 d-flex justify-content-between border-top">
              <span>最近动态</span>
              <router-link to="/logs" style="font-size:.85rem" title="查看更多动态">&gt;&gt; MORE</router-link>
            </div>
            <div class="pb-3">
              <ul>
                <li v-for="log in loglist" :key="log.id" class="d-flex pl-3 pr-3">
                  <JyBadge>{{ logstype[log.type] }}</JyBadge>
                  <span class="align-middle text-danger">{{ log.createuser }}</span>
                  <a class="align-middle" href="javascript:;" @click="doFoward(log)">{{ log.content }}</a>
                  <small class="align-middle text-muted">{{ log.createtime }}</small>
                </li>
              </ul>
            </div>
          </div>
        </form-item>
        <form-item label-width="0" class="mb-3 p0 border-none" style="flex:0 0 40%; width:40%;" no-hover align-v="flow-start">
          <div class="bg-white border rounded" style="height:291px;">
            <div class="p-3 h-100">
              <ve-histogram :data="chartData" :settings="chartSettings" height="100%" :grid="{top:40, bottom:10, left:10, right:10}" :extend="{barMaxWidth: 30}"></ve-histogram>
            </div>
          </div>
        </form-item>
        <form-item label-width="0" fill="4" class="mb-3 p0 border-none" no-hover align-v="flow-start">
          <div class="bg-white border rounded">
            <div class="p-3 font12">内容管理</div>
            <div class="row field bs-item ml-0 mr-0">
              <form-item label-width="0" class="mb-3 p0 border-none" no-hover align-v="flow-start">
                <router-link to="/news-add" class="d-block text-center border-right under-none">
                  <div class="font2"><i class="fa fa-plus"></i></div>
                  <div>添加内容</div>
                </router-link>
              </form-item>
              <form-item label-width="0" class="mb-3 p0 border-none" no-hover align-v="flow-start">
                <router-link to="/news-list" class="d-block text-center border-right under-none">
                  <div class="font2"><i class="fa fa-newspaper-o"></i></div>
                  <div>内容管理</div>
                </router-link>
              </form-item>
              <form-item label-width="0" class="mb-3 p0 border-none" no-hover align-v="flow-start">
                <router-link to="/news-single" class="d-block text-center border-right under-none">
                  <div class="font2"><i class="fa fa-list"></i></div>
                  <div>单项内容</div>
                </router-link>
              </form-item>
              <form-item label-width="0" class="mb-3 p0 border-none" no-hover align-v="flow-start">
                <router-link to="/web-setting" class="d-block text-center under-none">
                  <div class="font2"><i class="fa fa-cog"></i></div>
                  <div>网站设置</div>
                </router-link>
              </form-item>
            </div>
            <div class="p-2 pl-3 pr-3 bg-light border-top">
              <span class="text-secondary">快速链接：</span>
              <router-link to="/web-links" class="d-inline-block mr-4"><i class="fa fa-angle-right"></i> 链接管理</router-link>
            </div>
          </div>
        </form-item>
      </el-row>
    </el-form>
  </JyPagebody>
</template>
<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import JyProgress from 'jycomponents/progress/main';
import VeHistogram from 'v-charts/lib/histogram.common';
import tools from '@/utils/tools';
export default {
  components: {
    VeHistogram, JyProgress
  },
  mixins: [tools],
  data () {
    return {
      counts: {},
      stulist: [],
      countLoading: false,
      list1: [],
      list2: [],
      list3: [],
      listLoading: false,
      loglist: [],
      loglist2: [],
      logLoading: false,
      cateList: [],
      newsLoading: false,
      viewData: {},
      viewProductId: '',
      viewQuoteId: '',
      viewNewsId: '',
      editTitle: '',
      editSignupId: '',
      viewSignupId: '',
      groupData: {},
      addLeader: false,
      chartSettings: {
        stack: { '用户': ['总访问', '今日访问'] }
      },
    }
  },
  computed: {
    ...mapGetters({
      logstype: [types.STATUS.logstype]
    }),
    chartData() {
      let rows = this.stulist.map(d => {
        return ({ '日期': d.day, '总访问': d.count, '今日访问': d.countday });
      });
      return {
        columns: ['日期', '总访问', '今日访问'],
        rows: rows
      }
    }
  },
  mounted () {
    this.initData();
  },
  methods: {
    loadCounts() {
      this.counts = {};
      this.countLoading = true;
      this.doPost({
        url: 'sys/home',
        okcb: (json) => {
          this.counts = json;
          this.stulist = json.stulist;
        },
        cb: () => {
          this.$nextTick(() => {
            this.countLoading = false;
          });
        }
      });
    },
    loadList() {
      this.listLoading = true;
      this.doPost({
        url: 'sys/home/list',
        okcb: (json) => {
          this.list1 = json.list1;
          this.list2 = json.list2;
          this.list3 = json.list3;
        },
        cb: () => {
          this.$nextTick(() => {
            this.listLoading = false;
          });
        }
      });
    },
    loadLogList() {
      this.loglist = [];
      this.loglist2 = [];
      this.logLoading = true;
      this.doPost({
        url: 'sys/home/logs',
        okcb: (json) => {
          this.loglist = json.list;
          this.loglist2 = json.list2;
        },
        cb: () => {
          this.$nextTick(() => {
            this.logLoading = false;
          });
        }
      });
    },
    addPoint() {
      this.$refs.pointEdit.show(true);
    },
    loadNewsList() {
      this.newsLoading = true;
      this.doPost({
        url: 'sys/home/news',
        okcb: (json) => {
          this.cateList = json;
        },
        cb: () => {
          this.$nextTick(() => {
            this.newsLoading = false;
          });
        }
      });
    },
    doRoute(path) {
      this.$router.push(path);
    },
    doFoward(log) {
      if (log.type === 'news') {
        this.$router.push('/news-list');
      } else if (log.type === 'info') {
        this.$router.push('/info-list');
      } else if (log.type == 'point') {
        this.editData.pointid = log.businessid;
        this.pointView.show(true);
      } else if (log.type == 'area') {
        this.$router.push('/map-area');
      } else if (log.type == 'intro') {
        this.$router.push('/map-intro');
      } else if (log.type == 'config') {
        this.$router.push('/map-config');
      }
    },
    doViewNews(data) {
      this.viewNewsId = data.id;
      this.$refs.newsView.show(true);
    },
    initData() {
      if (!this.counts || !Object.keys(this.counts).length) {
        this.loadCounts();
      }
      if (!this.list1 || !this.list1.length
          || !this.list2 || !this.list2.length
          || !this.list3 || !this.list3.length
        ) {
        this.loadList();
      }
      if (!this.loglist || !this.loglist.length) {
        this.loadLogList();
      }
      if (!this.cateList || !this.cateList.length) {
        this.loadNewsList();
      }

      if (!this.logstype || !Object.keys(this.logstype).length) {
        this.$store.dispatch(types.STATUS.logstype);
      }
    }
  }
}
</script>
<style>
.home-logs .jy-tabs__item{height:auto; padding:.4rem .6rem; line-height:1.6; border-bottom:1px transparent solid;}
</style>
<style scoped>
.home-first >>> .el-form-item__content{line-height:1.65;}
.bs-item a{padding-top:1rem; padding-bottom:1rem; color:#1C86EE;}
.bs-item a:hover{background-color:#f5f5f5;}
.card-header, .card-body{padding:.4rem .6rem;}
.counts-table{border-color:transparent; border-collapse:separate; border-spacing:1rem;}
.counts-table td{vertical-align:middle; font-size:1.1rem; border-color:transparent; box-shadow:0 0 5px rgba(100,100,100,.2);}
.counts-table td.title{width:4rem; line-height:1.3; font-weight:bold; background-color:rgba(0,0,0,.03);}
.counts-table td.cursor-pointer:hover{box-shadow:0 0 8px rgba(255,0,0,.5);}
</style>
